/**
 * Maps API quote fields (gate_*, rotowire_lineup_state) to dashboard/overview display.
 * Backend: gate_reason "Rotowire:*" = lineup withhold; rotowire_lineup_state = snapshot semantic.
 */

export const ROTOWIRE_LINEUP_LABELS = {
  confirmed: 'Confirmed',
  expected: 'Expected',
  not_in_lineup: 'Not in snapshot',
  not_starting: 'Not starting',
  rotowire_not_enabled: 'Rotowire disabled',
  rotowire_no_feed: 'No feed / league mapping',
  unknown: 'Sleeper ID unknown',
};

export function rotowireLineupLabel(state) {
  if (state == null || state === '') return null;
  return ROTOWIRE_LINEUP_LABELS[state] || state;
}

export function isRotowireGateReason(gateReason) {
  return typeof gateReason === 'string' && gateReason.startsWith('Rotowire:');
}

/**
 * @returns {{
 *   badgeClass: string,
 *   badgeText: string,
 *   detail?: string,
 *   lineupHint?: string,
 * }}
 */
export function getQuoteGateDisplay(quote) {
  if (!quote) {
    return { badgeClass: 'badge-muted', badgeText: '—' };
  }
  if (quote.gate_allowed) {
    return { badgeClass: 'badge-success', badgeText: 'Allowed' };
  }
  const gr = quote.gate_reason || '';
  const rw = quote.rotowire_lineup_state;
  const lineupHint = rotowireLineupLabel(rw);

  if (isRotowireGateReason(gr)) {
    if (rw === 'not_starting') {
      return {
        badgeClass: 'badge-lineup-not-starting',
        badgeText: 'Blocked lineup\u00A0(rw)',
        detail: lineupHint ? undefined : gr,
        lineupHint,
      };
    }
    return {
      badgeClass: 'badge-lineup',
      badgeText: 'Blocked lineup\u00A0(rw)',
      detail: lineupHint ? undefined : gr,
      lineupHint,
    };
  }

  if (typeof gr === 'string' && gr.startsWith('Manual lineup:')) {
    return {
      badgeClass: 'badge-lineup',
      badgeText: 'Blocked lineup\u00A0(m)',
      detail: gr,
    };
  }

  if (typeof gr === 'string' && gr.startsWith('Derived market:')) {
    return {
      badgeClass: 'badge-error',
      badgeText: 'Blocked (parents)',
      detail: gr,
    };
  }

  return {
    badgeClass: 'badge-error',
    badgeText: 'Blocked',
    detail: gr || undefined,
  };
}
